/**
 * Single source of truth for the SDK version, embedded into the User-Agent
 * header and any public version surface.
 *
 * Kept in sync with package.json by the release workflow — the changeset
 * action edits both files in the same PR. If you update package.json by
 * hand, update this constant too.
 */
export const SDK_VERSION = '1.0.3';
